// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__v3cjE","rotate":"Spinner_rotate__deNLh","dash":"Spinner_dash__yRCu9"};